/**
 * Edition of a title as shown in the title list: the edition number when known,
 * otherwise the free-text edition statement, e.g. "2., doplněné vydání".
 */
export var formatEditionLabel = function (title) { var _a, _b; return (_b = (_a = title.editionNumber) !== null && _a !== void 0 ? _a : title.editionStatement) !== null && _b !== void 0 ? _b : ""; };
